<template>
    <v-snackbar 
		v-model="item.visibe"
		:color="item.color" 
		:timeout="item.timeout"
		variant="outlined"
		multi-line
	>
		{{ item.text }}
		<template v-slot:actions>
			<v-btn icon="mdi-window-close" @click="item.visibe = false"></v-btn>
		</template>
    </v-snackbar>
</template>

<script>
export default {
	components: {},
	data: () => ({
        
	}),
	
    props: {
		modelValue:			{ type: Object, default: () => {} },
	},

	/* watch: {
		'item.visibe'(val) {
			console.log('message', 'item.visibe', val)
		}
	}, */

	computed: {
        item: {
			get() 		{ return this.modelValue },
			set(val) 	{ this.$emit('update:modelValue', val) }
		},

        /* ...mapGetters({
            visible: 	'messageVisibe',
            type: 		'messageType',
            title: 		'messageTitle',
            text: 		'messageText',
            status: 	'messageStatus',
        }), */

		/* dialog: {
			get() 		{ return this.visible },
			set(val) 	{ this.$emit('input', val) }
		}, */

		/* color() {
			let result
			switch (this.type) {
				case "error": 	result = "error"; break;
				case "info": 	result = "info"; break;
				case "success": result = "success"; break;
				case "warning": result = "warning"; break;
				default:  		result = null;
			}
			return result
		}, */

		/* icon() {
			let result
			switch (this.type) {
				case "error": 	result = "mdi-alert-circle"; break;
				case "info": 	result = "mdi-information"; break;
				case "success": result = "mdi-check-circle"; break;
				case "warning": result = "mdi-alert"; break;
				default:  		result = null;
			}
			return result
		}, */

		/* timeout() {
			let result
			switch (this.type) {
				case "error": 	result = 7500; break;
				case "info": 	result = 0; break;
				case "success": result = 3000; break;
				case "warning": result = 5000; break;
				default:  		result = null;
			}
			return result
		}, */
    },
}
</script>